import React, { createContext, useContext, useState,useEffect } from "react";

const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
 
  const [selectedMenu, setSelectedMenu] = useState("Discover");
  const rolePermissionValue = localStorage.getItem("rolePermissionList");
  const userTypeValue = localStorage.getItem("userType")??[];
    const [rolePermissionList, setRolePermissionList] = useState(JSON.parse(rolePermissionValue)??[]);
             const [userType, setUserType] = useState(userTypeValue??"");
             useEffect(() => {
              console.log('rolePermissionValue',rolePermissionValue)
              localStorage.setItem("rolePermissionValue", rolePermissionList);
              localStorage.setItem("userTypeValue", userType);
            }, [rolePermissionList]);
  return (
    <GlobalContext.Provider value={{ rolePermissionList, setRolePermissionList, userType,setUserType,selectedMenu, setSelectedMenu }}>
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobal = () => useContext(GlobalContext);